
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getTabdata} from 'sr/utils/api/masterData/tabdata/getTabdata'
export const fetchtabdata = createAsyncThunk(
  'getTabdata',
  async () => {
    const response = await getTabdata()
    return response?.data
  }
)


